/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/8/31
 * @updateTime 2021/8/31
 * @decription 选择法院组件入口js
 */
// 标题栏
import acLayoutForm from '@/components/app/layout/form/index.vue';
// tab模块组件
import tabModule from './tab-module/index.vue';
export default {
    name: 'ac-select-court',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acLayoutForm,
        tabModule
    },
    // 参数
    props: {
        // 类型 1、保全、2担保、3复议
        mklx: {
            type: String|Number,
            default: 1
        }
    },
    // 数据
    data() {
        return {
            // 当前作用域变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-ac-select-court'
            },
            // 活跃的tab项
            active: 0,
            // 法院数据
            courtData: {
                // 高级法院列表
                gj: [],
                // 中级法院列表
                zj: [],
                // 基层法院列表
                jc: []
            },
            // 选中的信息项数据
            activeItem: null,
            // 当前所处法院级别 0根级 1 高级 2 中级 3 基层
            currentLevel: 0
        };
    },
    // 计算属性
    computed: {
        /**
         * 容器类名
         * @returns {Array<String>} 类名数组
         * */
        wrapClasses() {
            return [
                this.scope.prefixCls
            ];
        }
    },
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 初始化方法
        this.init();
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {
        /**
         * 初始化不需要更新的数据
         * @returns {void}
         * */
        initNoUpdateData() {
            // 法院map对象
            this.courtMap = {};
        },

        /**
         * 根据法院id请求对应的法院列表
         * @param {String} fyid 法院id
         * @returns {Promise}
         * */
        requestCourtList(fyid) {
            return this.$axios.get('ssbq/api/xcx/fy', {
                mklx: this.mklx,
                fyid: fyid
            });
        },

        /**
         * 获取法院数据
         * @param {String} fyid 法院id
         * @param {Number} level 法院级别 0根级 1 高级 2 中级 3 基层
         * @returns {void}
         * */
        getCourtData(fyid, level) {
            // 成功的回调函数
            const _successCB = (data) => {
                switch (level) {
                    case 0:
                        this.courtData.gj = data;
                        break;
                    case 1:
                        this.courtData.zj = data;
                        break;
                    case 2:
                        this.courtData.jc = data;
                        break;
                }
            }
            // 如果法院map中已经请求过了，则直接拿，否则请求获取并存储
            if (this.courtMap[fyid]) {
                _successCB(this.courtMap[fyid]);
            } else {
                this.requestCourtList(fyid).then(res => {
                    const _data = res.data;
                    this.courtMap[fyid] = _data;
                    _successCB(_data);
                });
            }
        },

        /**
         * 初始化方法
         * */
        init() {
            // 初始化不需要更新的数据
            this.initNoUpdateData();
            // 请求高院列表数据
            this.getCourtData('0', 0);
        },

        /**
         * 点击选择法院
         * @param {Object} item 法院数据
         * @param {Number} level 法院级别 0根级 1 高级 2 中级 3 基层
         * @returns {void}
         * */
        eClickCourt(item, level) {
            // 请求对应的id
            this.getCourtData(item.id, level);
            // 赋值选中的信息项
            this.activeItem = item;
            // 当前法院级别
            this.currentLevel = level;
        },
        /**
         * 点击确定按钮事件
         * @returns {void}
         * */
        eClickSure() {
            // 向上分发确定事件
            this.$emit('confirm', this.activeItem);
        },

        /**
         * 点击返回
         * @returns {void}
         * */
        back() {
            this.$emit('cancel');
        }
    }
};
